export const removeTrailingSlash = (url = '') => url.replace(/\/$/, '');

/**
 * Sanitise search string from user when searching for page or space.
 */
export function sanitizeInput(input = ''): string {
	// The double quotes don't need to be balanced, as the backend handles this fine (static String ensureBalancedDoubleQuotes(String str))
	return input.replace(/"|'|\*|~|\\/g, '\\$&');
}

/**
 * Generate a Confluence Page ARI.
 * Borrowed from lp-graph src/services/ariUrl/providers.ts
 * resourceId is a sequence of digits after pages/ in the page url.
 * https://bitbucket.org/atlassian/lp-graph/src/b7b2a76b2a56b6a0093cc57401412c4575623914/src/services/ariUrl/providers.ts#lines-79
 */

export function confluencePageAri({
	cloudId,
	resourceId,
}: {
	cloudId: string;
	resourceId: string;
}) {
	return `ari:cloud:confluence:${cloudId}:page/${resourceId}`;
}
